import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

interface Props {
  icon: React.ReactElement;
  name: string;
  path?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const theme = createTheme({
  typography: {
    button: {
      fontSize: 18,
      fontWeight: 800,
      textTransform: 'none',
    },
  },
  palette: {
    primary: { main: '#fff' },
  },
});

export default function NavbarMenuButton({ icon, name, path, onClick }: Props) {
  const navigate = useNavigate();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    } else if (path) {
      navigate(path, { viewTransition: true });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Button variant="text" startIcon={icon} onClick={handleClick}>
        {name}
      </Button>
    </ThemeProvider>
  );
}
